export default [
  {
    name: "GetUserMenuPermissions",
    url: "/menu/permissions",
    method: "GET",
    mock: false,
  },
];
